(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["category-circles"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initDots(dotsEl) {
      if (!dotsEl || dotsEl.dataset.dotsInitialized === 'true') return;

      var carousel = document.getElementById(dotsEl.dataset.dotsFor || '');
      var buttons = Array.prototype.slice.call(dotsEl.querySelectorAll('button'));
      if (!carousel || buttons.length === 0) return;

      dotsEl.dataset.dotsInitialized = 'true';

      var items = Array.prototype.slice.call(carousel.children);

      function setActive(index) {
        buttons.forEach(function (button, i) {
          button.setAttribute('aria-current', i === index ? 'true' : 'false');
        });
      }

      function closestIndex() {
        var center = carousel.scrollLeft + carousel.clientWidth / 2;
        var closest = 0;
        var closestDistance = Infinity;
        items.forEach(function (item, i) {
          var itemCenter = item.offsetLeft + item.offsetWidth / 2;
          var distance = Math.abs(itemCenter - center);
          if (distance < closestDistance) {
            closestDistance = distance;
            closest = i;
          }
        });
        return closest;
      }

      var scrollTimer = null;
      carousel.addEventListener(
        'scroll',
        function () {
          setActive(closestIndex());
          if (scrollTimer) window.clearTimeout(scrollTimer);
          scrollTimer = window.setTimeout(function () {
            setActive(closestIndex());
          }, 120);
        },
        { passive: true }
      );

      buttons.forEach(function (button, index) {
        button.addEventListener('click', function () {
          var item = items[index];
          if (!item) return;
          carousel.scrollTo({
            left: item.offsetLeft - (carousel.clientWidth - item.offsetWidth) / 2,
            behavior: 'smooth'
          });
        });
      });
    }

    function initAll(root) {
      (root || document).querySelectorAll('[data-category-circles-dots]').forEach(initDots);
    }

    initAll(document);

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["see-it-in-action"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initSection(root) {
      if (!root || root.dataset.siiaInitialized === 'true') return;
      root.dataset.siiaInitialized = 'true';

      var marquee = root.querySelector('[data-siia-marquee]');
      var track = root.querySelector('[data-siia-track]');
      if (!marquee || !track) return;

      var pauseOnHover = root.dataset.pauseOnHover === 'true';
      var dragScroll = root.dataset.dragScroll === 'true';

      var reduceMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

      function handlePauseOnHover() {
        if (!pauseOnHover) return;
        root.addEventListener('mouseenter', function () {
          root.classList.add('is-paused');
        });
        root.addEventListener('mouseleave', function () {
          root.classList.remove('is-paused');
        });
      }

      function handleDragScroll() {
        if (!dragScroll || reduceMotionQuery.matches) return;

        marquee.setAttribute('data-siia-dragscroll', 'true');

        var isPointerDown = false;
        var startX = 0;
        var scrollStart = 0;
        var resumeTimer = null;

        function pauseAutoScroll() {
          marquee.classList.remove('is-auto-scrolling');
          if (resumeTimer) {
            window.clearTimeout(resumeTimer);
            resumeTimer = null;
          }
        }

        function scheduleResume() {
          if (resumeTimer) window.clearTimeout(resumeTimer);
          resumeTimer = window.setTimeout(function () {
            marquee.classList.add('is-auto-scrolling');
          }, 1500);
        }

        marquee.addEventListener(
          'pointerdown',
          function (event) {
            isPointerDown = true;
            startX = event.clientX;
            scrollStart = marquee.scrollLeft;
            pauseAutoScroll();
            marquee.setPointerCapture(event.pointerId);
          },
          { passive: true }
        );

        marquee.addEventListener(
          'pointermove',
          function (event) {
            if (!isPointerDown) return;
            var delta = event.clientX - startX;
            marquee.scrollLeft = scrollStart - delta;
          },
          { passive: true }
        );

        function endDrag() {
          if (!isPointerDown) return;
          isPointerDown = false;
          scheduleResume();
        }

        marquee.addEventListener('pointerup', endDrag, { passive: true });
        marquee.addEventListener('pointercancel', endDrag, { passive: true });
        marquee.addEventListener('pointerleave', endDrag, { passive: true });

        marquee.classList.add('is-auto-scrolling');
      }

      function handleReducedMotion() {
        function apply() {
          if (reduceMotionQuery.matches) {
            marquee.style.overflowX = 'auto';
          }
        }
        apply();
        if (reduceMotionQuery.addEventListener) {
          reduceMotionQuery.addEventListener('change', apply);
        }
      }

      handlePauseOnHover();
      handleDragScroll();
      handleReducedMotion();
    }

    function destroySection(root) {
      if (!root) return;
      root.dataset.siiaInitialized = 'false';
    }

    document.querySelectorAll('[data-section-id][id^="see-it-in-action-"]').forEach(initSection);

    document.addEventListener('shopify:section:load', function (event) {
      var root = event.target.querySelector
        ? event.target.querySelector('[id^="see-it-in-action-"]')
        : null;
      if (root) initSection(root);
    });

    document.addEventListener('shopify:section:unload', function (event) {
      var root = event.target.querySelector
        ? event.target.querySelector('[id^="see-it-in-action-"]')
        : null;
      if (root) destroySection(root);
    });

    document.addEventListener('shopify:block:select', function (event) {
      var blockElement = event.target;
      if (!blockElement || !blockElement.closest) return;
      var root = blockElement.closest('[id^="see-it-in-action-"]');
      if (!root) return;
      root.classList.add('is-paused');
      blockElement.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
    });

    document.addEventListener('shopify:block:deselect', function (event) {
      var blockElement = event.target;
      if (!blockElement || !blockElement.closest) return;
      var root = blockElement.closest('[id^="see-it-in-action-"]');
      if (!root) return;
      root.classList.remove('is-paused');
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
